export const NO_AUTH_REQUIRED = 'noAuthRequired' as const;
